var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1766 0.5H4.07268C2.58266 0.5 1.63825 2.10728 2.38788 3.40663L7.38929 12.0755C7.71566 12.6415 8.53357 12.6415 8.85994 12.0755L13.8624 3.40663C14.611 2.10936 13.6666 0.5 12.1776 0.5H12.1766ZM7.38522 9.47581L6.296 7.36776L3.66782 2.66721C3.49444 2.36635 3.70859 1.98082 4.07166 1.98082H7.38421V9.47683L7.38522 9.47581ZM12.5794 2.6662L9.95221 7.36878L8.86299 9.47581V1.9798H12.1755C12.5386 1.9798 12.7528 2.36534 12.5794 2.6662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonButton);
export default __webpack_public_path__ + "static/media/ton_button.ab85511058b9f4225cc968f3c64b4a75.svg";
export { ForwardRef as ReactComponent };